import React from 'react'
import Landing from '../components/Landing'
import Projects from '../components/Projects'
import Services from '../components/Services'
import Clients from '../components/Clients'
import Footer from '../components/Footer'
import Header from '../components/Header'
import EduExp from '../components/EduExp'

export default function Home() {
  return (
    <div className='container-xxl'>
      <Header />
      <Landing />
      <Services />
      <EduExp />
      <Projects />
      <Clients />
      <Footer />
    </div>
  )
}
